import {
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Tooltip,
    Typography,
    useTheme,
} from '@material-ui/core'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Container, MessageForm, SideDrawer } from '../../components'
import { workorderContext } from '../../contexts'
import { toast } from 'react-toastify'
import {
    getChangeOrderConfigListRequest,
    getUserList,
    RootState,
    WorkorderResponse,
} from '../../store'
import { useAppDispatch, usePagination, useUser } from '../../hooks'
import { useCompany } from '../../hooks/useCompany'
import { useChangeOrder } from '../../hooks/useChangeOrder'
import { Pagination } from '@material-ui/lab'
import { AI_LIST_FOOTER_H } from '../ActionItem/contants'
import { EZWorkWorkorderFilters } from './EZWorkWorkorderFilters'
import { Section, SectionList } from '../../components/SectionList'
import {
    IdBoolMap,
    ModelMap,
    convertMapToList,
    BULK_TRANSITION,
    BaseWorkorder,
    ApartmentVendor,
    User,
    SEE_VENDOR_FINANCES,
    SEE_INCOME_FINANCES,
} from '../../models'
import { AiDrawerId, AiFormState, closedAiFormState } from '../ActionItem/types'
import { WorkorderDetail } from './WorkorderDetail'
import { CreateChangeOrderModal } from './CreateChangeOrderModal'
import { ChangeOrderListModal } from '../ChangeOrder/ChangeOrderListModal'
import { useMessage } from '../../hooks/useMessage'
import { WorkorderRow } from '../../components/WorkorderLib/WorkorderRow/WorkorderRow'
import { axiosInstance, VENDOR } from '../../helpers'
import Close from '@material-ui/icons/Close'
import DoneAll from '@material-ui/icons/DoneAll'
import EditIcon from '@material-ui/icons/Edit'
import SyncAlt from '@material-ui/icons/SyncAlt'
import GetApp from '@material-ui/icons/GetApp'
import { BulkTransitionEditor } from '../Scheduler_v2/Drawers/BulkTransitionEditor'
import { AssignSubsModal } from './AssignSubsModal'
import { SliceAssignModal } from './SliceAssignModal'
import { VendorInvoiceCodeGate } from '../Invoice/VendorInvoiceCodeGate'
import {
    INVOICE_CODE_STEP,
    SEND_INVOICE_STEP,
    useVendorInvoice,
} from '../../contexts/useVendorInvoice'
import { hasPermission } from '../../models/Users/services'
import { downloadItemizedWorkorderReport } from '../../models/WorkOrder/services'
import { typographyStyle } from '../../theme/typographyStyle'

export const EZWorkWorkorderList = () => {
    const [formState, setFormState] = useState<AiFormState>(closedAiFormState)
    const [openCreateChangeOrder, setOpenCreateChangeOrder] = useState(false)
    const [openChangeOrderList, setOpenChangeOrderList] = useState(false)
    const [transitionModalOpen, setTransitionModalOpen] = useState(false)

    const [assignSubsModalOpen, setAssignSubsModalOpen] = useState(false)
    const [assignSubsInvoiceGateOpen, setAssignSubsInvoiceGateOpen] = useState(
        false,
    )
    const [reportInvoiceGateOpen, setReportInvoiceGateOpen] = useState(false)
    const [reportDialogOpen, setReportDialogOpen] = useState(false)
    const [sliceAssignModalOpen, setSliceAssignModalOpen] = useState(false)
    const [
        sliceAssignInvoiceGateOpen,
        setSliceAssignInvoiceGateOpen,
    ] = useState(false)

    const openDetailDrawer = (selectionId: number, drawerId: AiDrawerId) => {
        setFormState({
            ...closedAiFormState,
            detailFormOpen: {
                index: -1,
                id: selectionId,
                drawerId: drawerId,
            },
        })
    }

    const {
        filteredWorkorderList,
        updateWorkorderState,
        loadingState,
        transitionWorkorder,
        workorderSelectionMap,
        setWorkorderSelectionMap,
        superTransitionWorkorders,
        getServiceRequestChannel,
        createWorkorderEarlyAccessRequest,
        batchAssignSubcontractors,
        refetchWorkorderList,
    } = workorderContext()

    const sortedWorkorders = filteredWorkorderList.sort((woA, woB) => {
        if (woA.apartment_id > woB.apartment_id) {
            return 1
        } else if (woA.apartment_id < woB.apartment_id) {
            return -1
        }
        return 0
    })

    const { page, setPage, pageData, numPages, start, end } = usePagination(
        sortedWorkorders ?? [],
    )

    const { createMessage } = useMessage()

    const { apartmentList, getApartmentList } = useCompany()

    const { workspaceUser } = useUser()
    const dispatch = useAppDispatch()
    const changeOrderController = useChangeOrder()
    const changeOrderConfigList = useSelector(
        (state: RootState) => state.aptConfig.changeOrderConfigList,
    )

    const vendorInvoiceController = useVendorInvoice()
    const isVendorUser =
        workspaceUser?.active_workspace?.company_type === VENDOR

    const [assignSubsTeamUsers, setAssignSubsTeamUsers] = useState<User[]>([])
    const [
        assignSubsTeamUsersLoading,
        setAssignSubsTeamUsersLoading,
    ] = useState(false)

    const [canSeeUnitNotesMap, setCanSeeUnitNotesMap] = useState<IdBoolMap>({})

    const selectedWo: WorkorderResponse | undefined = sortedWorkorders.find(
        (workorder) => workorder.id === formState.detailFormOpen.id,
    )

    const [selectionMode, setSelectionMode] = useState(false)

    useEffect(() => {
        if (!openChangeOrderList || selectedWo === undefined) {
            return
        }
        const lowerBound = new Date()
        lowerBound.setFullYear(lowerBound.getFullYear() - 2)
        void changeOrderController.getChangeOrderList({
            lower_bound_date: lowerBound.toISOString(),
            workorder: selectedWo.id,
        })
        dispatch(
            getChangeOrderConfigListRequest({
                params: { jobsite: selectedWo.apartment_id },
            }),
        )
    }, [
        openChangeOrderList,
        selectedWo?.id,
        selectedWo?.apartment_id,
        dispatch,
    ])

    useEffect(() => {
        if (vendorInvoiceController.step === INVOICE_CODE_STEP) {
            setAssignSubsModalOpen(false)
        }
    }, [vendorInvoiceController.step])

    useEffect(() => {
        if (!assignSubsModalOpen && !sliceAssignModalOpen) {
            return
        }
        let cancelled = false
        setAssignSubsTeamUsersLoading(true)
        void dispatch(getUserList({ params: { my_team: true } }))
            .then((res) => {
                if (cancelled) return
                const data = (res as { data?: User[] })?.data
                setAssignSubsTeamUsers(Array.isArray(data) ? data : [])
            })
            .catch(() => {
                if (!cancelled) {
                    toast.error('Could not load team members.')
                    setAssignSubsTeamUsers([])
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setAssignSubsTeamUsersLoading(false)
                }
            })
        if (sliceAssignModalOpen) {
            void getApartmentList({ params: {} })
        }
        return () => {
            cancelled = true
        }
    }, [assignSubsModalOpen, sliceAssignModalOpen, dispatch])

    useEffect(() => {
        axiosInstance.get('company/apartment_vendors/').then((res) => {
            const newUnitNoteMap: IdBoolMap = {}
            res.data.forEach((aptVendor: ApartmentVendor) => {
                newUnitNoteMap[aptVendor.apartment.id] =
                    aptVendor.vendor_see_unit_notes
            })
            setCanSeeUnitNotesMap(newUnitNoteMap)
        })
    }, [])

    const theme = useTheme()

    const sections = useMemo(() => {
        return createWorkorderApartmentSections(pageData)
    }, [pageData])

    const workorders = useMemo(
        () => (selectionMode ? convertMapToList(workorderSelectionMap) : []),
        [selectionMode, workorderSelectionMap],
    )

    let numberSelected = 0
    if (selectionMode) {
        numberSelected = Object.keys(workorderSelectionMap).length
    }

    const noWorkordersSelected = workorders.length === 0
    const selectWorkorderFirstTooltip =
        'Click a workorder in the list to select it.'
    const enterSelectionModeForBulkTooltip =
        'Turn on Select Workorders to use this.'

    const selectWorkordersDisabled = !hasPermission(
        workspaceUser,
        BULK_TRANSITION,
    )

    const bulkActionsDisabled = !selectionMode || noWorkordersSelected

    const filteredTotalCount = sortedWorkorders.length

    // Vendors always see their own costs; SEE_VENDOR_FINANCES is apartment-only.
    const showCost =
        isVendorUser || hasPermission(workspaceUser, SEE_VENDOR_FINANCES)
    const showIncome = hasPermission(workspaceUser, SEE_INCOME_FINANCES)

    const handleToggleSelectionMode = () => {
        if (selectionMode) {
            setWorkorderSelectionMap({})
        }
        setSelectionMode((prev) => !prev)
    }

    const handleSelectAllFiltered = () => {
        const next: ModelMap<WorkorderResponse> = {}
        sortedWorkorders.forEach((wo) => {
            next[wo.id] = wo
        })
        setWorkorderSelectionMap(next)
    }

    const today = new Date()

    const openServiceRequestChannel = (workorder: WorkorderResponse) => {
        if (workorder.service_request) {
            if (workorder.service_request.channel_id) {
                setFormState({
                    ...formState,
                    detailFormOpen: {
                        ...formState.detailFormOpen,
                        id: workorder.id,
                        drawerId: AiDrawerId.serviceRequest,
                    },
                })
            } else {
                getServiceRequestChannel(workorder).then((channelId) => {
                    setFormState({
                        ...formState,
                        detailFormOpen: {
                            ...formState.detailFormOpen,
                            id: workorder.id,
                            drawerId: AiDrawerId.serviceRequest,
                        },
                    })
                })
            }
        }
    }

    return (
        <Container
            flex={1}
            direction="column"
            style={{
                margin: theme.spacing(1),
                width: '100%',
                alignItems: 'stretch',
                minHeight: 0,
            }}
        >
            <Container
                direction="row"
                style={{
                    flex: 1,
                    width: '100%',
                    minHeight: 0,
                    justifyContent: 'center',
                    alignItems: 'stretch',
                }}
            >
                <Container
                    direction="column"
                    style={{
                        width: '650px',
                        flexShrink: 0,
                        minHeight: 0,
                    }}
                >
                    {loadingState.getWorkorderList ? (
                        <Container
                            style={{
                                flex: 1,
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: 'calc(100vh - 200px)',
                            }}
                        >
                            <CircularProgress size={100} />
                        </Container>
                    ) : (
                        <Container
                            direction="column"
                            scrollY
                            style={{
                                maxHeight: 'calc(100vh - 200px)',
                                minHeight: 'calc(100vh - 200px)',
                            }}
                            flex={1}
                        >
                            <SectionList
                                sections={sections}
                                theme={theme}
                                renderItem={(workorder: WorkorderResponse) => {
                                    return (
                                        <WorkorderRow
                                            key={`EZWORK_WORKORDER_ROW_${workorder.id}`}
                                            workorder={workorder}
                                            canSeeUnitNotes={
                                                canSeeUnitNotesMap[
                                                    workorder.apartment_id
                                                ]
                                            }
                                            openMessageDrawer={() => {
                                                openDetailDrawer(
                                                    workorder.id,
                                                    AiDrawerId.message,
                                                )
                                            }}
                                            openUnitNotes={() => {
                                                openDetailDrawer(
                                                    workorder.id,
                                                    AiDrawerId.unitNotes,
                                                )
                                            }}
                                            transitionWorkorder={
                                                transitionWorkorder
                                            }
                                            user={workspaceUser}
                                            onClickWorkorder={(
                                                wo: WorkorderResponse,
                                            ) => {
                                                if (selectionMode) {
                                                    const newEditSelection = {
                                                        ...workorderSelectionMap,
                                                    }

                                                    if (
                                                        newEditSelection[
                                                            workorder.id
                                                        ] !== undefined
                                                    ) {
                                                        delete newEditSelection[
                                                            workorder.id
                                                        ]
                                                    } else {
                                                        newEditSelection[
                                                            workorder.id
                                                        ] = workorder
                                                    }

                                                    setWorkorderSelectionMap(
                                                        newEditSelection,
                                                    )
                                                } else {
                                                    setFormState({
                                                        ...formState,
                                                        detailFormOpen: {
                                                            ...formState.detailFormOpen,
                                                            id: wo.id,
                                                            drawerId: null,
                                                        },
                                                    })
                                                }
                                            }}
                                            isSelectedWorkorder={
                                                selectionMode
                                                    ? workorderSelectionMap[
                                                          workorder.id
                                                      ] !== undefined
                                                    : workorder.id ===
                                                      selectedWo?.id
                                            }
                                            updateWorkorderState={
                                                updateWorkorderState
                                            }
                                            createMessage={createMessage}
                                            selectionMode={selectionMode}
                                            width={650}
                                            disabled={
                                                new Date(workorder.start_date) >
                                                today
                                            }
                                            openServiceRequestChannel={
                                                openServiceRequestChannel
                                            }
                                            onCreateWorkorderEarlyAccessRequest={
                                                createWorkorderEarlyAccessRequest
                                            }
                                        />
                                    )
                                }}
                                renderSectionHeader={(section) => {
                                    return (
                                        <Container
                                            style={{
                                                ...typographyStyle(
                                                    theme.typography.h5,
                                                ),
                                                fontWeight:
                                                    theme.typography
                                                        .fontWeightBold,
                                                width: '100%',
                                                height: 60,
                                                padding: theme.spacing(1),
                                                borderBottom: `1px solid ${theme.palette.grey[400]}`,
                                                borderTop: `1px solid ${theme.palette.grey[400]}`,
                                                backgroundColor:
                                                    theme.palette.grey[200],

                                                alignItems: 'center',
                                            }}
                                        >
                                            {section.title}
                                        </Container>
                                    )
                                }}
                            />
                        </Container>
                    )}
                    <Container
                        style={{
                            borderTop: `1px solid ${theme.palette.grey[400]}`,
                            padding: theme.spacing(1),
                            minHeight: AI_LIST_FOOTER_H,
                            maxHeight: AI_LIST_FOOTER_H,
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Pagination
                            count={numPages}
                            page={page}
                            onChange={(_: unknown, newPage: number) => {
                                setPage(newPage)
                            }}
                        />
                        <span>
                            {start} - {end} of {sortedWorkorders.length}
                        </span>
                    </Container>
                </Container>
                <Divider
                    orientation="vertical"
                    flexItem
                    style={{ flexShrink: 0 }}
                />
                <Container
                    direction="column"
                    style={{
                        flexShrink: 0,
                        width: `calc(450px + ${theme.spacing(
                            2,
                        )} + ${theme.spacing(2)})`,
                        boxSizing: 'border-box',
                        padding: theme.spacing(1, 2, 0),
                        minHeight: 0,
                    }}
                >
                    <EZWorkWorkorderFilters />
                    <Container
                        direction="column"
                        style={{
                            backgroundColor: theme.palette.grey[50],
                            border: `1px solid ${theme.palette.grey[300]}`,
                            borderRadius:
                                typeof theme.shape.borderRadius === 'number'
                                    ? theme.shape.borderRadius
                                    : 8,
                            boxSizing: 'border-box',
                            boxShadow: theme.shadows[1],
                            padding: theme.spacing(2),
                            minWidth: 450,
                            maxWidth: 450,
                            marginBottom: theme.spacing(2),
                        }}
                    >
                        <Typography
                            variant="subtitle2"
                            color="textSecondary"
                            style={{
                                marginBottom: theme.spacing(1),
                                fontWeight: theme.typography.fontWeightBold,
                            }}
                        >
                            Selection
                        </Typography>
                        <Button
                            fullWidth
                            color={selectionMode ? 'default' : 'primary'}
                            disabled={selectWorkordersDisabled}
                            onClick={handleToggleSelectionMode}
                            startIcon={selectionMode ? <Close /> : <EditIcon />}
                            style={{
                                marginBottom: theme.spacing(2),
                                textTransform: 'none',
                                ...(!selectWorkordersDisabled &&
                                    (selectionMode
                                        ? {
                                              backgroundColor:
                                                  theme.palette.error.light,
                                              color: theme.palette.error.dark,
                                          }
                                        : {
                                              backgroundColor:
                                                  theme.palette.primary.dark,
                                              color: 'white',
                                          })),
                            }}
                            variant="contained"
                        >
                            {selectionMode ? 'Cancel' : 'Enter Selection Mode'}
                        </Button>
                        {isVendorUser && !workspaceUser?.is_sub_vendor && (
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={() => {
                                    if (
                                        vendorInvoiceController.step !==
                                        SEND_INVOICE_STEP
                                    ) {
                                        setSliceAssignInvoiceGateOpen(true)
                                    } else {
                                        setSliceAssignModalOpen(true)
                                    }
                                }}
                                size="small"
                                style={{
                                    marginBottom: theme.spacing(2),
                                    textTransform: 'none',
                                }}
                            >
                                Assign by property & service
                            </Button>
                        )}
                        <Container
                            direction="row"
                            style={{
                                width: '100%',
                                marginBottom: theme.spacing(2),
                                alignItems: 'stretch',
                                gap: theme.spacing(1),
                            }}
                        >
                            <Tooltip
                                disableHoverListener={!bulkActionsDisabled}
                                title={
                                    bulkActionsDisabled
                                        ? selectionMode
                                            ? selectWorkorderFirstTooltip
                                            : enterSelectionModeForBulkTooltip
                                        : ''
                                }
                            >
                                <span
                                    style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'inline-flex',
                                    }}
                                >
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        disabled={bulkActionsDisabled}
                                        onClick={() =>
                                            setTransitionModalOpen(true)
                                        }
                                        size="small"
                                        startIcon={<SyncAlt />}
                                        style={{
                                            textTransform: 'none',
                                            ...(!bulkActionsDisabled && {
                                                backgroundColor:
                                                    theme.palette.primary.dark,
                                                color: 'white',
                                            }),
                                        }}
                                    >
                                        Bulk Transition
                                    </Button>
                                </span>
                            </Tooltip>
                            <Tooltip
                                disableHoverListener={!bulkActionsDisabled}
                                title={
                                    bulkActionsDisabled
                                        ? selectionMode
                                            ? selectWorkorderFirstTooltip
                                            : enterSelectionModeForBulkTooltip
                                        : ''
                                }
                            >
                                <span
                                    style={{
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'inline-flex',
                                    }}
                                >
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        disabled={bulkActionsDisabled}
                                        onClick={() => {
                                            if (
                                                isVendorUser &&
                                                vendorInvoiceController.step !==
                                                    SEND_INVOICE_STEP
                                            ) {
                                                setAssignSubsInvoiceGateOpen(
                                                    true,
                                                )
                                            } else {
                                                setAssignSubsModalOpen(true)
                                            }
                                        }}
                                        size="small"
                                        startIcon={<DoneAll />}
                                        style={{
                                            textTransform: 'none',
                                            ...(!bulkActionsDisabled && {
                                                backgroundColor:
                                                    theme.palette.primary.dark,
                                                color: 'white',
                                            }),
                                        }}
                                    >
                                        Assign Subs
                                    </Button>
                                </span>
                            </Tooltip>
                        </Container>
                        {selectionMode && (
                            <>
                                <Typography
                                    style={{
                                        ...typographyStyle(theme.typography.h6),
                                        fontWeight: 700,
                                        marginBottom: theme.spacing(1),
                                    }}
                                >
                                    {numberSelected} selected
                                </Typography>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    disabled={filteredTotalCount === 0}
                                    onClick={handleSelectAllFiltered}
                                    style={{
                                        marginBottom: theme.spacing(1),
                                        textTransform: 'none',
                                    }}
                                >
                                    Select all ({filteredTotalCount})
                                </Button>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    disabled={numberSelected === 0}
                                    onClick={() => setWorkorderSelectionMap({})}
                                    style={{ textTransform: 'none' }}
                                    startIcon={<Close />}
                                >
                                    Deselect all ({numberSelected})
                                </Button>
                            </>
                        )}
                        <Divider
                            style={{ margin: theme.spacing(2, 0, 2, 0) }}
                        />
                        <Button
                            fullWidth
                            variant="outlined"
                            onClick={() => setReportDialogOpen(true)}
                            startIcon={<GetApp />}
                            disabled={sortedWorkorders.length === 0}
                            style={{
                                textTransform: 'none',
                            }}
                        >
                            Download Excel Report
                        </Button>
                    </Container>
                    <Divider style={{ margin: theme.spacing(1, 0, 1, 0) }} />
                    <Container style={{ padding: theme.spacing(2) }}>
                        {selectedWo && (
                            <WorkorderDetail
                                workorder={selectedWo}
                                canSeeUnitNotes={
                                    canSeeUnitNotesMap[selectedWo.apartment_id]
                                }
                                setOpenCreateChangeOrder={
                                    setOpenCreateChangeOrder
                                }
                                setOpenChangeOrderList={setOpenChangeOrderList}
                            />
                        )}
                    </Container>
                </Container>
            </Container>
            <SideDrawer
                open={
                    selectedWo?.id === formState.detailFormOpen.id &&
                    formState.detailFormOpen.drawerId === AiDrawerId.message
                }
                width={400}
                handleClose={() =>
                    setFormState({
                        ...formState,
                        detailFormOpen: {
                            ...formState.detailFormOpen,
                            drawerId: null,
                        },
                    })
                }
            >
                <MessageForm
                    theme={theme}
                    channelId={selectedWo?.channel}
                    secondaryChannelId={selectedWo?.inv_ins_channel}
                    afterCreateMessage={() => {
                        if (selectedWo) {
                            updateWorkorderState({
                                ...selectedWo,
                                message_count:
                                    (selectedWo.message_count ?? 0) + 1,
                            })
                        }
                    }}
                    secondaryTitle="From Inventory Inspection"
                />
            </SideDrawer>
            <SideDrawer
                open={
                    selectedWo?.id === formState.detailFormOpen.id &&
                    formState.detailFormOpen.drawerId === AiDrawerId.unitNotes
                }
                width={400}
                handleClose={() =>
                    setFormState({
                        ...formState,
                        detailFormOpen: {
                            ...formState.detailFormOpen,
                            drawerId: null,
                        },
                    })
                }
                title={`Unit Notes ${selectedWo?.unit_name ?? ''}`}
            >
                <MessageForm
                    theme={theme}
                    channelId={selectedWo?.unit_channel_id ?? undefined}
                    afterCreateMessage={() => {
                        if (selectedWo) {
                            updateWorkorderState({
                                ...selectedWo,
                                unit_notes_msg_count:
                                    (selectedWo.unit_notes_msg_count ?? 0) + 1,
                            })
                        }
                    }}
                />
            </SideDrawer>
            <SideDrawer
                open={
                    selectedWo?.id === formState.detailFormOpen.id &&
                    selectedWo?.service_request !== null &&
                    formState.detailFormOpen.drawerId ===
                        AiDrawerId.serviceRequest
                }
                width={400}
                handleClose={() =>
                    setFormState({
                        ...formState,
                        detailFormOpen: {
                            ...formState.detailFormOpen,
                            drawerId: null,
                        },
                    })
                }
                title={'Tenant Service Request'}
            >
                <MessageForm
                    theme={theme}
                    channelId={
                        selectedWo?.service_request?.channel_id ?? undefined
                    }
                    afterCreateMessage={() => {
                        if (selectedWo && selectedWo.service_request) {
                            updateWorkorderState({
                                ...selectedWo,
                                service_request: {
                                    ...selectedWo.service_request,
                                    message_count:
                                        (selectedWo.service_request
                                            .message_count ?? 0) + 1,
                                    unread_count: 0,
                                },
                            })
                        }
                    }}
                />
            </SideDrawer>
            {selectedWo && (
                <CreateChangeOrderModal
                    workorder={selectedWo}
                    open={openCreateChangeOrder}
                    handleClose={() => setOpenCreateChangeOrder(false)}
                />
            )}
            <ChangeOrderListModal
                open={openChangeOrderList}
                theme={theme}
                changeOrderConfigList={changeOrderConfigList ?? []}
                workspaceUser={workspaceUser}
                changeOrderController={changeOrderController}
                workorder={selectedWo}
                onClose={() => setOpenChangeOrderList(false)}
            />
            <AssignSubsModal
                batchAssignSubcontractors={batchAssignSubcontractors}
                isOpen={assignSubsModalOpen}
                onClose={() => setAssignSubsModalOpen(false)}
                onSuccess={() => {
                    setWorkorderSelectionMap({})
                    setSelectionMode(false)
                }}
                submitting={loadingState.batchAssignSubcontractors}
                userList={assignSubsTeamUsers}
                userListLoading={assignSubsTeamUsersLoading}
                vendorId={workspaceUser?.active_workspace?.id ?? null}
                workorders={workorders}
            />
            <SliceAssignModal
                apartmentList={apartmentList.map((a) => ({
                    id: a.id,
                    name: a.name ?? '',
                }))}
                isOpen={sliceAssignModalOpen}
                onClose={() => setSliceAssignModalOpen(false)}
                onSuccess={() => {
                    void refetchWorkorderList()
                }}
                userList={assignSubsTeamUsers}
                userListLoading={assignSubsTeamUsersLoading}
            />
            <Dialog
                open={assignSubsInvoiceGateOpen}
                onClose={() => setAssignSubsInvoiceGateOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    <VendorInvoiceCodeGate
                        layout="dialog"
                        onValidated={() => {
                            setAssignSubsInvoiceGateOpen(false)
                            setAssignSubsModalOpen(true)
                        }}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={reportDialogOpen}
                onClose={() => setReportDialogOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Download Excel Report</DialogTitle>
                <DialogContent>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            setReportDialogOpen(false)
                            downloadItemizedWorkorderReport(
                                sortedWorkorders,
                                showCost,
                                showIncome,
                                false,
                            )
                        }}
                        startIcon={<GetApp />}
                        style={{
                            textTransform: 'none',
                            marginBottom: theme.spacing(2),
                        }}
                    >
                        Download Report
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            setReportDialogOpen(false)
                            if (
                                isVendorUser &&
                                vendorInvoiceController.step !==
                                    SEND_INVOICE_STEP
                            ) {
                                setReportInvoiceGateOpen(true)
                            } else {
                                downloadItemizedWorkorderReport(
                                    sortedWorkorders,
                                    showCost,
                                    showIncome,
                                    true,
                                )
                            }
                        }}
                        startIcon={<GetApp />}
                        style={{
                            textTransform: 'none',
                            marginBottom: theme.spacing(1),
                        }}
                    >
                        Download with Sub Vendor Pricing
                    </Button>
                </DialogContent>
            </Dialog>
            <Dialog
                open={reportInvoiceGateOpen}
                onClose={() => setReportInvoiceGateOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    <VendorInvoiceCodeGate
                        layout="dialog"
                        onValidated={() => {
                            setReportInvoiceGateOpen(false)
                            downloadItemizedWorkorderReport(
                                sortedWorkorders,
                                showCost,
                                showIncome,
                                true,
                            )
                        }}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={sliceAssignInvoiceGateOpen}
                onClose={() => setSliceAssignInvoiceGateOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    <VendorInvoiceCodeGate
                        layout="dialog"
                        onValidated={() => {
                            setSliceAssignInvoiceGateOpen(false)
                            setSliceAssignModalOpen(true)
                        }}
                    />
                </DialogContent>
            </Dialog>
            <BulkTransitionEditor
                workorders={workorders}
                isOpen={transitionModalOpen}
                handleBulkTransitionClose={() => setTransitionModalOpen(false)}
                setSelectedWorkorders={(
                    selectedWorkorders: ModelMap<
                        WorkorderResponse | BaseWorkorder
                    >,
                ) =>
                    setWorkorderSelectionMap(
                        selectedWorkorders as ModelMap<WorkorderResponse>,
                    )
                }
                handleBulkEditClose={() => {
                    setWorkorderSelectionMap({})
                    setSelectionMode(false)
                }}
                superTransitionWorkorders={superTransitionWorkorders}
                isVendor
            />
        </Container>
    )
}

const createWorkorderApartmentSections = (workorders: WorkorderResponse[]) => {
    const sections: Section<WorkorderResponse>[] = []
    const apartments: ModelMap<{
        name: string
        id: number
    }> = {}

    if (workorders.length > 0) {
        apartments[workorders[0].apartment_id] = {
            name: workorders[0].apartment_name ?? '',
            id: workorders[0].apartment_id,
        }
    }

    workorders.forEach((workorder) => {
        if (apartments[workorder.apartment_id] === undefined) {
            apartments[workorder.apartment_id] = {
                name: workorder.apartment_name ?? '',
                id: workorder.apartment_id,
            }
        }
    })

    const apartmentList = convertMapToList(apartments)

    apartmentList.forEach((apartment) => {
        sections.push({
            title: apartment.name,
            data: workorders.filter(
                (workorder) => workorder.apartment_id === apartment.id,
            ),
            identifier: apartment.id,
        })
    })

    return sections
}
